//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Footer from "@/components/lyx-components/lyx-footer/index";
import EsQuery from '@/javascript/esQuery'
import util from '@/javascript/util'
import goBack from '@/components/public-components/goBack/index.vue'

export default {
  components: {
    Footer,
    goBack
  },
  data () {
    return {
      isWeixin: util.isWeiXin(),
      tabsListPageNo: 0,//分页
      tabsListPageSize: 10,//每一页取的数据条数
      infiniteStatus: false,//控制加载 ture停止加载,false的话根据infiniteAll判断
      infiniteAll: false,//在infiniteStatus为false的情况下,infiniteAll为false停止加载，true继续加载
      tabsList: [],//请求数据列表
      areaList: [{
        title: '全部'//下拉列表地区
      }],
      curArea: 0,//用来判断下拉菜单的高亮
      popupState: false,//控制下拉菜单的显示隐藏
      placeholder: '搜索景区\\攻略\\游记\\酒店\\美食',
      minHeight: 0,
      cityName: {}
    }
  },
  mounted () {
    this.minHeight = document.documentElement.clientHeight - this.$refs.topBox.offsetHeight - this.$refs.footer.$el.offsetHeight;
    const title = this.$route.query.type && this.$route.query.type == 'z' ? '专题' : '攻略'
    document.title = title
    /**
     * 微信签名分享
     */
    // if (this.isWeixin) {
    //   const shareData = typeof (shareData) === 'undefined' ? {
    //     title: this.PAGE_TITLE + title,
    //     desc: '太行美景 幸福涉县，河北涉县欢迎您~',
    //     imgUrl: window.location.origin + '/static/zg-img/banner_img.png',
    //     link: window.location.href
    //   } : shareData;

    //   this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href) + '&appId=' + this.WX_APPID).then((response) => {
    //     util.initWxConfig(response.data.data, shareData)
    //   })
    // }


    this.getStrList()

    // 触发滚动
    window.addEventListener('scroll', () => {
      if (util.pullUpLoad()) {
        this.infinite()
      }
    })
  },
  methods: {
    // 触发加载
    infinite: function () {//判断是不是第一次滚动触发的加载
      if (this.infiniteAll) {
        return
      }
      if (this.infiniteStatus) {
        return
      }
      if (this.tabsList.length == 0) {
        return
      }
      this.infiniteStatus = true
      this.tabsListPageNo += 1
      this.getStrList()
    },
    //请求数据
    getStrList: function () {
      const querystring3 = require('querystring');
      const strategyEsQuery3 = new EsQuery()
      strategyEsQuery3.addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, strategyEsQuery3.and, false)
        .addPage(this.tabsListPageNo * this.tabsListPageSize, this.tabsListPageSize)
      // .addString("publishStatus", 1, strategyEsQuery3.and, false)
      // .addSort("weight", strategyEsQuery3.desc, false)
      if (this.$route.query.type && this.$route.query.type == 'z') {
        strategyEsQuery3.addString("kind", 2, strategyEsQuery3.and, false)
      } else {
        strategyEsQuery3.addString("kind", 1, strategyEsQuery3.and, false)
      }
      const strategyEsJsonQuery3 = JSON.stringify(strategyEsQuery3.getArray())
      this.$http.post('api/wtcp-kb/pub/doc/search', querystring3.stringify({
        indexName: 'wtcp-tips',
        esJsonQuery: strategyEsJsonQuery3
      })).then((response) => {
        const list = response.data.data
        list.map((item) => {
          item._source.regionName = item._source.regionName ? item._source.regionName.split(',')[2] : ''
          // if (item._source.titleImage && item._source.titleImage.indexOf('\\') != -1) {
          //   item._source.titleImage = item._source.titleImage.replaceAll("\\", "/\/")
          // }
        })
        this.tabsList = this.tabsList.concat(list)
        if (response.data.data.length < this.tabsListPageSize) {//如果请求到的数据少于10条
          this.infiniteAll = true//没有更多啦
        }
        this.infiniteStatus = false//加载完数据之后让加载提示不再显示

      })
    },
    togglePopup: function () {
      this.popupState = !this.popupState
    },
    changeArea: function (index) {
      this.curArea = index
      this.tabsListPageNo = 0
      this.infiniteStatus = false
      this.infiniteAll = false
      this.tabsList = []
      this.popupState = false
      this.getStrList()
    }
  }
}
